export const FEEDBACK_LOADING = "FEEDBACK_LOADING";
export const FEEDBACK_CLEAR = "FEEDBACK_CLEAR";
export const FEEDBACK = "FEEDBACK";
